import importerStore from '@shared/importer/importer-store';
import { SchoolService } from '@modules/school/school-service';
import schoolImporterFields from '@modules/school/school-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
        SchoolService.import,
        schoolImporterFields,
        i18n('entities.school.importer.fileName'),
        i18n('entities.school.importer.hint'),
);